<template>
  <div class="app-main">
     <!-- 非个人中心显示 -->
    <blockquote v-if="isShow_background">
      <commenTop v-if=" activeIndex != 0 && activeIndex != 3 && $store.state.isShowJobInfo "
        :title="'行业专家'" :EnglishTitle="'INDUSTRY EXPERTS'" 
        :tabData="tabData"
        :breadcrumbData="breadcrumbData">
      </commenTop>
    </blockquote> 
    <transition name="fade-transform" mode="out-in"> 
      <div :class="(activeIndex != 0 && activeIndex != 7 && activeIndex != 3) ? 'main_page' : '' ">
        <router-view :key="key" />
		
      </div>
    </transition>
	
  </div>
</template>

<script>
import commenTop from '@/components/commenTop.vue';
export default {
  components: {
    commenTop
  },
  computed: {
    key() {
      return this.$route.path
    }
  },
  data() {
    return {
      activeIndex: 0,// 当前导航激活的页面index
      // isShow_jobInfo: this.$store.state.isShow_jobInfo, // 招聘大厅-岗位信息
      isShow_background: true, // 是否显示nav背景信息(个人中心需隐藏)
      userType: '',
      tabData: [],
      breadcrumbData: []
    }
  },
  
  mounted() {
    //  console.log('isShow_jobInfo',this.$store.state.isShowJobInfo);
    this.activeIndex = sessionStorage.getItem('activeIndex') ? sessionStorage.getItem('activeIndex') : 0;
	 
    // this.isShow_jobInfo = sessionStorage.getItem('jobInfo') ? true : false;
    // console.log('isShow_jobInfo',this.isShow_jobInfo);
    this.userType = JSON.parse(localStorage.getItem('identity')); // 2个人， 3企业
    // if(this.userType == 3 && this.activeIndex > 3) this.activeIndex = Number(this.activeIndex) + 1;
    if(this.activeIndex == 1){
      this.tabData = [
          {
              id: 0,
              name: '国内要闻',
              path: '/information/index/0'
          },{
              id: 1,
              name: '行业动态',
              path: '/information/index/1'
          },{
              id: 2,
              name: '政策法规',
              path: '/information/index/2'
          },{
              id: 3,
              name: '国企招聘',
              path: '/information/index/3'
          }
      ],
      this.breadcrumbData = [
          {
              id: 0,
              name: '首页',
              path: '/'
          },{
              id: 1,
              name: '行业资讯',
              path: '/information/index/0'
          }
      ]
    }else  if(this.activeIndex == 2) {
      this.tabData = [
          {
              id: 0,
              name: '培训报名',
              path: '/training/enlist'
          },{
              id: 1,
              name: '培训机构',
              path: '/training/agency'
          },{
              id: 2,
              name: '培训文章',
              path: '/training/article'
          },{
              id: 3,
              name: '培训视频',
              path: '/training/video'
          }
      ],
      this.breadcrumbData = [
          {
              id: 0,
              name: '首页',
              path: '/'
          },{
              id: 1,
              name: '培训中心',
              path: '/training/enlist'
          }
      ]
    }else  if(this.activeIndex == 3) {
      this.tabData = [
          // {
          //     id: 0,
          //     name: '培训报名',
          //     path: '/training/enlist'
          // },{
          //     id: 1,
          //     name: '培训机构',
          //     path: '/training/agency'
          // },{
          //     id: 2,
          //     name: '培训文章',
          //     path: '/training/article'
          // },{
          //     id: 3,
          //     name: '培训视频',
          //     path: '/training/video'
          // }
      ],
      this.breadcrumbData = [
          {
              id: 0,
              name: '首页',
              path: '/'
          },{
              id: 1,
              name: '咨询服务',
              path: '/consulting'
          }
      ]
    }else  if(this.activeIndex == 4) {
      this.tabData = [
      {
              id: 0,
              name: '热招岗位',
              path: '/recruitment/postList'
          },{
              id: 1,
              name: '热门企业',
              path: '/recruitment/enterpriseList'
          },
      ],
      this.breadcrumbData = [
          {
              id: 0,
              name: '首页',
              path: '/'
          },{
              id: 1,
              name: ' 招聘大厅',
              path: '/recruitment/postList'
          }
      ]
    }else  if(this.activeIndex == 5) {
      this.tabData = [
      {
              id: 0,
              name: '专家列表',
              path: '/experts/expertslist'
          },{
              id: 1,
              name: '问答列表',
              path: '/experts/answering'
          },
      ],
      this.breadcrumbData = [
          {
              id: 0,
              name: '首页',
              path: '/'
          },{
              id: 1,
              name: '行业专家',
              path: '/experts/expertslist'
          }
      ]
    }else  if(this.activeIndex == 6) {
      this.tabData = [
      {
              id: 0,
              name: '招投标信息',
              path: '/opportunity/tender'
          },{
              id: 1,
              name: '设备供需',
              path: '/opportunity/supply'
          },
      ],
      this.breadcrumbData = [
          {
              id: 0,
              name: '首页',
              path: '/'
          },{
              id: 1,
              name: '业内商机',
              path: '/opportunity/tender'
          }
      ]
    }else  if(this.activeIndex == 7) {
      this.tabData = [],
      this.breadcrumbData = [
          {
              id: 0,
              name: '首页',
              path: '/'
          },{
              id: 1,
              name: '合作发展',
              path: '/cooperate'
          }
      ]
    }else{
      this.isShow_background = false;
    }
  },
  watch: {
    // isShow_jobInfo:function(val){
    //     this.test()
    // } ,
    $route:{
        handler () {
          // this.$emit('navigationBar');
          if(this.$route.path.indexOf('enterpriseCenter') > -1 || this.$route.path.indexOf('personalCenter') > -1 || this.$route.path.indexOf('agreement') > -1){  // 个人中心
            this.isShow_background = false;
          }else{
            this.isShow_background = true;
          }

          // this.$nextTick(() => {
          //   setTimeout(()=>{
          //     if(sessionStorage.getItem('jobInfo') || sessionStorage.getItem('enterpriseInfo')){
          //       // sessionStorage.setItem('isShow_jobInfo', false);
          //       // this.isShow_jobInfo = false
          //       this.$store.commit('SET_ISSHOWJOBINFO', false)
          //     } else {
          //       // sessionStorage.setItem('isShow_jobInfo', true);
          //       // this.isShow_jobInfo = true
          //       this.$store.commit('SET_ISSHOWJOBINFO', true)
          //     }
          //   console.log('isShow_jobInfo',this.$store.state.isShowJobInfo);
          //   },500)
          // });

          this.activeIndex = sessionStorage.getItem('activeIndex'); 
          // if(this.userType == 3 && this.activeIndex > 3) this.activeIndex = Number(this.activeIndex) + 1;
          if(this.activeIndex == 1){
            this.tabData = [
                {
                    id: 0,
                    name: '国内要闻',
                    path: '/information/index/0'
                },{
                    id: 1,
                    name: '行业动态',
                    path: '/information/index/1'
                },{
                    id: 2,
                    name: '政策法规',
                    path: '/information/index/2'
                },{
                    id: 3,
                    name: '国企招聘',
                    path: '/information/index/3'
                }
            ],
            this.breadcrumbData = [
                {
                    id: 0,
                    name: '首页',
                    path: '/'
                },{
                    id: 1,
                    name: '行业资讯',
                    path: '/information/index/0'
                }
            ]
          }else  if(this.activeIndex == 2) {
            this.tabData = [
                {
                    id: 0,
                    name: '培训报名',
                    path: '/training/enlist'
                },{
                    id: 1,
                    name: '培训机构',
                    path: '/training/agency'
                },{
                    id: 2,
                    name: '培训文章',
                    path: '/training/article'
                },{
                    id: 3,
                    name: '培训视频',
                    path: '/training/video'
                }
            ],
            this.breadcrumbData = [
                {
                    id: 0,
                    name: '首页',
                    path: '/'
                },{
                    id: 1,
                    name: '培训中心',
                    path: '/training/enlist'
                }
            ]
          }else  if(this.activeIndex == 3) {
            this.tabData = [],
            this.breadcrumbData = [
                {
                    id: 0,
                    name: '首页',
                    path: '/'
                },{
                    id: 1,
                    name: '咨询服务',
                    path: '/consulting'
                }
            ]
          }else  if(this.activeIndex == 4) {
            this.tabData = [
            {
                    id: 0,
                    name: '热招岗位',
                    path: '/recruitment/postList'
                },{
                    id: 1,
                    name: '热门企业',
                    path: '/recruitment/enterpriseList'
                },
            ],
            this.breadcrumbData = [
                {
                    id: 0,
                    name: '首页',
                    path: '/'
                },{
                    id: 1,
                    name: ' 招聘大厅',
                    path: '/recruitment/postList'
                }
            ]
          }else  if(this.activeIndex == 5) {
            this.tabData = [
            {
                    id: 0,
                    name: '专家列表',
                    path: '/experts/expertslist'
                },{
                    id: 1,
                    name: '问答列表',
                    path: '/experts/answering'
                },
            ],
            this.breadcrumbData = [
                {
                    id: 0,
                    name: '首页',
                    path: '/'
                },{
                    id: 1,
                    name: '行业专家',
                    path: '/experts/expertslist'
                }
            ]
          }else  if(this.activeIndex == 6) {
            this.tabData = [
            {
                    id: 0,
                    name: '招投标信息',
                    path: '/opportunity/tender'
                },{
                    id: 1,
                    name: '设备供需',
                    path: '/opportunity/supply'
                },
            ],
            this.breadcrumbData = [
                {
                    id: 0,
                    name: '首页',
                    path: '/'
                },{
                    id: 1,
                    name: '业内商机',
                    path: '/opportunity/tender'
                }
            ]
          }else  if(this.activeIndex == 7) {
            this.tabData = [],
            this.breadcrumbData = [
                {
                    id: 0,
                    name: '首页',
                    path: '/'
                },{
                    id: 1,
                    name: '合作发展',
                    path: '/cooperate'
                }
            ]
          }
        },
        deep: true,
      },
  },
  method: {
   
    test(){
      console.log('test==')
    },
    
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/index.scss";
.app-main {
  /*84 = navbar  */
  min-height: calc(100vh - 781px);
  width: 100%;
  height: 100%;
  /* height: calc(100vh - 84px); */
  /* margin-top: 84px; */
  position: relative;
  overflow: hidden;
  /* background-color: #E4E7EA; */
}
.fixed-header+.app-main {
  padding-top: 84px;
}
.main_page{
  padding:  0 $padding-both;
  background-color: #fff;
  min-height: calc(100vh - 300px);
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
